// ============================================================================
// TextFilter.jsx — Corelia UI v1.2
// Champ de recherche normalisé basé sur FormLayout + theme.form
// ============================================================================
import React from "react";
import theme from "../../../styles/theme";
import FormLayout from "./FormLayout";

const TextFilter = ({
  label,
  labelPosition = "left",
  labelWidth = 100,
  align = "center",

  value,
  onChange,
  placeholder = "Rechercher...",
  error,
  disabled,

  width = "100%",
  style = {},
  inputStyle = {},
}) => {
  const isDisabled = !!disabled;

  return (
    <FormLayout
      label={label}
      labelPosition={labelPosition}
      labelWidth={labelWidth}
      align={align}
      width={width}
      style={style}
    >
      <div style={{ position: "relative", width: "100%" }}>
        <input
          type="text"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={isDisabled}
          style={{
            width: "100%",
            minHeight: theme.form.field.minHeight,
            padding: `${theme.form.field.paddingV}px ${theme.form.field.paddingH}px ${theme.form.field.paddingV}px 36px`,

            // Typographie homogène
            fontFamily: theme.form.field.fontFamily,
            fontSize: theme.form.field.fontSize,
            fontWeight: theme.form.field.fontWeight,
            color: theme.form.field.color,

            // Bordures
            borderRadius: theme.form.field.borderRadius,
            border: error
              ? `1px solid ${theme.colors.text.danger}`
              : theme.form.field.border,

            // Background
            backgroundColor: isDisabled
              ? theme.form.disabled.background
              : theme.form.field.background,

            outline: "none",
            transition: "border-color 0.2s ease",
            boxSizing: "border-box",

            // Icône de recherche
            backgroundImage: "url('/assets/icones/search.svg')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "16px 16px",
            backgroundPosition: "10px center",

            ...inputStyle,
          }}
          onFocus={(e) =>
            (e.target.style.borderColor = theme.form.focus.borderColor)
          }
          onBlur={(e) =>
            (e.target.style.borderColor = error
              ? theme.colors.text.danger
              : theme.colors.borders.default)
          }
        />

        {error && (
          <p
            style={{
              color: theme.colors.text.danger,
              fontSize: theme.fontSizes.sm,
              marginTop: 4,
            }}
          >
            {error}
          </p>
        )}
      </div>
    </FormLayout>
  );
};

export default TextFilter;
